export default __webpack_public_path__ + "static/media/bachmans-404.77e86c9c.svg";